<template>
  <div class="Cookie" v-if="isOpen">
    <div class="Cookie__content">
      <slot name="message">Like most websites we use cookies to improve your experience. By use of this site we will assume your acceptance</slot>
      <button @click="accept">Accept</button>
      <router-link :to="buttonLink" v-if="buttonLink" rel="noopener" aria-label="Cookies read more">Read more</router-link>
    </div>
  </div>
</template>

<script>
let isBrowser = typeof window !== 'undefined'
export default {
  name: 'cookie-law',
  data() {
    return {
      isOpen: false,
      buttonLink: '/about/legal#privacy',
    }
  },
  created() {
    if (!this.getVisited() === true) {
      this.isOpen = true
    }
  },
  methods: {
    setVisited: function setVisited() {
      if (isBrowser && window.localStorage) {
        window.localStorage.setItem('cookie:accepted', true)
      }
    },
    getVisited: function getVisited() {
      if (isBrowser && window.localStorage) {
        return window.localStorage.getItem('cookie:accepted')
      } else {
        return false
      }
    },
    accept() {
      this.setVisited()
      this.isOpen = false
    },
  },
}
</script>

<style lang="scss">
.Cookie {
  position: fixed;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 9999;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-direction: column;
  > * {
    margin: rem(15) 0;
    align-self: center;
  }
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 4px solid #444;
  font-size: 1.2rem;
  background: #fff;
  padding: 0.4rem 0;
  button {
    background: #000;
    font-weight: bold;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 5px;
    background: #7d7e7d; /* Old browsers */
    background: -moz-linear-gradient(
      top,
      #7d7e7d 0%,
      #0e0e0e 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      top,
      #7d7e7d 0%,
      #0e0e0e 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to bottom,
      #7d7e7d 0%,
      #0e0e0e 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(
      startColorstr='#7d7e7d',
      endColorstr='#0e0e0e',
      GradientType=0
    ); // IE6-9
  }
  a {
    color: #444;
  }
}
</style>
